import { render, staticRenderFns } from "./stureport.vue?vue&type=template&id=6bcfcce2&scoped=true&"
import script from "./stureport.vue?vue&type=script&lang=js&"
export * from "./stureport.vue?vue&type=script&lang=js&"
import style0 from "./stureport.vue?vue&type=style&index=0&id=6bcfcce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfcce2",
  null
  
)

export default component.exports